import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

/*
 * touch events
 * */
import Vue2TouchEvents from 'vue2-touch-events'

import router from './router'
Vue.use(Vue2TouchEvents, {
  swipeTolerance: 150
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
